/* Judge.mes widget skriver gennemsnittet som "4.56 ud af 5".
   Teksten kommer fra deres eget script efter indlæsning og kan derfor ikke
   sættes med Liquid. Her kortes den til tallet alene, med komma på de sprog
   der bruger komma. Sker der intet, står Judge.mes egen tekst — intet går tabt. */
(function () {
  var maal = document.querySelector('.bt-anm-widget');
  if (!maal) return;
  var runder = 0;
  var t = setInterval(function () {
    runder++;
    if (runder > 30) clearInterval(t);
    var a = maal.querySelector('.jdgm-rev-widg__summary-average .jdgm-link, .jdgm-rev-widg__summary-average');
    if (!a) return;
    var m = (a.textContent || '').match(/[\d]+([.,][\d]+)?/);
    if (!m) return;
    var sprog = (document.documentElement.lang || 'da').toLowerCase();
    var tal = m[0];
    if (sprog.indexOf('en') !== 0) tal = tal.replace('.', ',');
    if (a.textContent.trim() !== tal) a.textContent = tal;
  }, 500);
})();

/* Judge.mes nye widget (sep. 2026) tegner stjernerne som tegnene U+E000 (fuld),
   U+E001 (tom) og U+E002 (halv) i sin egen ikonskrift, som viser smileys.
   Vi mærker hver stjerne, så CSS kan tegne et rigtigt ★ i den rigtige farve,
   viser snittet med komma og stjerner under (Judge.mes eget tal skjules).
   Widgeten tegnes om ved sortering og sidetal, derfor en observer. */
(function () {
  var maal = document.querySelector('.bt-anm-widget');
  if (!maal || !window.MutationObserver) return;
  var typer = { '\ue000': 'on', '\ue001': 'off', '\ue002': 'half' };
  var sprog = (document.documentElement.lang || 'da').toLowerCase();
  function ret() {
    maal.querySelectorAll('.jm-star-rating__font-icon').forEach(function (s) {
      var t = typer[(s.textContent || '').trim()] || 'on';
      if (s.getAttribute('data-bt-stjerne') !== t) s.setAttribute('data-bt-stjerne', t);
    });
    var boks = maal.querySelector('.jm-average-rating-display > .jm-cluster');
    if (!boks) return;
    var tal = boks.querySelector('p');
    if (!tal) return;
    var m = (tal.textContent || '').match(/\d+([.,]\d+)?/);
    if (!m) return;
    var vist = m[0];
    if (sprog.indexOf('en') !== 0) vist = vist.replace('.', ',');
    var snit = boks.querySelector('.bt-anm-snit');
    if (snit && snit.getAttribute('data-tal') === vist) return;
    if (snit) snit.remove();
    var v = parseFloat(m[0].replace(',', '.'));
    var halv = Math.round(v * 2) / 2;
    snit = document.createElement('span');
    snit.className = 'bt-anm-snit';
    snit.setAttribute('data-tal', vist);
    var talEl = document.createElement('span');
    talEl.className = 'bt-anm-snit__tal';
    talEl.textContent = vist;
    var raekke = document.createElement('span');
    raekke.className = 'bt-anm-snit__stjerner';
    raekke.setAttribute('aria-hidden', 'true');
    for (var i = 1; i <= 5; i++) {
      var st = document.createElement('span');
      st.setAttribute('data-bt-stjerne', i <= Math.floor(halv) ? 'on' : (i === Math.ceil(halv) && halv % 1 ? 'half' : 'off'));
      raekke.appendChild(st);
    }
    snit.appendChild(talEl);
    snit.appendChild(raekke);
    tal.insertAdjacentElement('afterend', snit);
  }
  var venter = false;
  new MutationObserver(function () {
    if (venter) return;
    venter = true;
    requestAnimationFrame(function () { venter = false; ret(); });
  }).observe(maal, { childList: true, subtree: true, characterData: true });
  ret();
})();
